import { v4 as uuidv4 } from 'uuid'

export const defaultFormData = {
	id: uuidv4(),
	policyNumber: null,
	// isSubmited: false,
	currentStep: 1,
	// applicationId: 0,
	policyHolder: {
		details: {
			salutationId: null,
			surname: '',
			forename: '',
			dateOfBirth: '',
			genderId: '',
			occupationId: '',
			jobTitle: '',
			industry: '',
			residenceCountryId: '',
			nationalityCountryId: '',
			isTaxEnable: false, // residence country = portugal => enable = true
			taxIdentificationNumber: '',
			insuredId: '',
		},

		contactDetails: {
			lineNumberCountryCodeId: null,
			landlineNumber: '',
			countryCodeMobileId: null,
			mobileNumber: '',
			emailAddress: '',
		},

		additionalDetails: {
			isSportOrPastime: null,
			pastimeId: null,
			otherPastimes: '',

			refusedCoverOrAcceptedOnSpecialTerms: null,
			refusedCoverOrAcceptedOnSpecialTermsDate: null,
			refusedCoverOrAcceptedOnSpecialTermsDetails: '',

			smoking: null,
			smokingAnswerHowMany: '',

			haveExistingHealthInsurance: undefined,
			insuranceProvider: null,

			bmi: {
				unit: 0,
				centimeters: undefined,
				kilograms: undefined,
				feets: undefined,
				inches: undefined,
				stones: undefined,
				pounds: undefined,
			},

			countryResidenceAddress: {
				address1: '',
				address2: '',
				address3: '',
				state: '',
				city: '',
				zipCode: '',
				countryId: null,
			},

			homeCountryAddress: {
				address1: '',
				address2: '',
				address3: '',
				state: '',
				city: '',
				zipCode: '',
				countryId: null,
			},

			physicianDetails: {
				salutationId: null,
				forename: '',
				surname: '',
				practiceName: '',
				dateLastVisited: undefined,
				email: '',
				countryCodeId: null,
				telephoneNumber: '',
				address: {
					address1: '',
					address2: '',
					address3: '',
					state: '',
					city: '',
					countryId: null,
					zipCode: '',
				},
				haveExistingHealthInsurance: undefined,
				insuranceProvider: null,
			},

			documents: [],
			fileUploaded: [],
		},
	},

	currentSelectedFamilyIndex: undefined,
	familyMembers: [],
	policyDetails: {
		policyStartDate: 123,
		policyHolderInsured: true,
		currencyId: '',
	},

	// Evolution Health
	selectedProductIndex: 0,
	product: {
		productId: -1,
		areaId: -1,
		levelOfCoverId: -1,
		frequencyId: -1,
		selectedExcessId: -1,
		coInsuranceSelectedId: [],
		additionalBenefitSelectedListId: [],

		// tax
		taxType: null,
		taxPercent: 0,
		taxValue: 0,
	},

	underwritingTypeId: '',
	underwritingQuestions: [],
	underwritingQuestionsCount: 0,

	certificateGenerate: false,
}

export const getSessionFormData = function () {
	let sessionFormData = sessionStorage.getItem('formData')
	if (!sessionFormData) {
		return null
	} else {
		return JSON.parse(sessionFormData)
	}
}

export const initFamilyMember = function () {
	return {
		id: uuidv4(),
		details: {
			salutationId: null,
			forename: '',
			surname: '',
			dateOfBirth: '',
			genderId: '',
			occupationId: '',
			jobTitle: '',
			industry: '',
			nationalityCountryId: undefined,
			relationshipId: undefined,
			insuredId: '',
		},
		additionalDetails: {
			isSportOrPastime: true,
			pastimeId: null,
			otherPastimes: '',

			smoking: null,
			smokingAnswerHowMany: '',

			refusedCoverOrAcceptedOnSpecialTerms: null,
			refusedCoverOrAcceptedOnSpecialTermsDate: null,
			refusedCoverOrAcceptedOnSpecialTermsDetails: '',
			bmi: {
				unit: 0,
				centimeters: undefined,
				kilograms: undefined,
				feets: undefined,
				inches: undefined,
				stones: undefined,
				pounds: undefined,
			},
			physicianDetails: {
				physicianSamePolicyHolder: false,
				salutationId: null,
				forename: '',
				surname: '',
				practicename: '',
				dateLastVisited: undefined,
				email: '',
				countryCodeId: null,
				telephoneNumber: '',
				address: {
					address1: '',
					address2: '',
					address3: '',
					state: '',
					city: '',
					countryId: null,
					zipCode: '',
				},

				healthInsuraceSamePolicyHolder: false,
				haveExistingHealthInsurance: undefined,
				insuranceProvider: null,
			},
			documents: [],
			fileUploaded: [],
		},
		underwritingQuestions: [],
	}
}

export const setSessionFormData = function (formData) {
	sessionStorage.setItem('formData', JSON.stringify(formData))
}

export const setDefaultProductFormData = function () {
	return {
		productId: -1,
		areaId: -1,
		levelOfCoverId: -1,
		frequencyId: -1,
		selectedExcessId: -1,
		coInsuranceSelectedId: [],
		additionalBenefitSelectedListId: [],

		// tax
		taxType: null,
		taxPercent: 0,
		taxValue: 0,
	}
}

export const setDefaultPhysicianDetail = function () {
	return {
		physicianSamePolicyHolder: false,
		salutationId: null,
		forename: '',
		surname: '',
		practicename: '',
		dateLastVisited: undefined,
		email: '',
		countryCodeId: null,
		telephoneNumber: '',
		address: {
			address1: '',
			address2: '',
			address3: '',
			state: '',
			city: '',
			countryId: undefined,
			zipCode: '',
		},

		healthInsuraceSamePolicyHolder: false,
		haveExistingHealthInsurance: undefined,
		insuranceProvider: null,
	}
}

export const setDefaultPolicyHolderDetail = function () {
	return {
		physicianSamePolicyHolder: false,
		salutationId: null,
		forename: '',
		surname: '',
		practicename: '',
		dateLastVisited: undefined,
		email: '',
		countryCodeId: null,
		telephoneNumber: '',
		address: {
			address1: '',
			address2: '',
			address3: '',
			state: '',
			city: '',
			countryId: undefined,
			zipCode: '',
		},

		healthInsuraceSamePolicyHolder: false,
		haveExistingHealthInsurance: undefined,
		insuranceProvider: null,
	}
}

export const clearSessionFormData = () => {
	sessionStorage.removeItem('formData')
}

export const getSummaryData = function (vueApp) {
	const summary = {}

	summary.productSelected = vueApp.$quote.products.find((p) => p.productID == vueApp.$formData.product.productId)

	summary.currency = vueApp.$optionData.currencies.find(
		(c) => c.value == vueApp.$formData.policyDetails.currencyId,
	).field1

	summary.areaSelected = summary.productSelected.areasOfCover.find(
		(a) => a.areaOfCoverID == vueApp.$formData.product.areaId,
	)

	summary.levelOfCover = summary.areaSelected.levelsOfCover.find(
		(l) => l.levelOfCoverID == vueApp.$formData.product.levelOfCoverId,
	)

	// Get in quote, if quote null get from local storage
	let voluntaryExcessSelected = summary.levelOfCover.voluntaryExcesses.find((e) => e.isSelected)
	if (!voluntaryExcessSelected) {
		voluntaryExcessSelected = summary.levelOfCover.voluntaryExcesses.find(
			(e) => e.voluntaryExcessID === vueApp.$formData.product.selectedExcessId,
		)
	} else {
		// Set value into local storage in first execute
		vueApp.$formData.product.selectedExcessId = voluntaryExcessSelected.voluntaryExcessID
	}
	summary.voluntaryExcessSelected = voluntaryExcessSelected

	// Co-insurance is !null && !empty
	let coInsuranceListSelected = summary.levelOfCover.coInsures.filter((e) => e.isSelected),
		selectedCoInsuranceIds = vueApp.$formData.product.coInsuranceSelectedId
	if (coInsuranceListSelected.length === 0) {
		coInsuranceListSelected = summary.levelOfCover.coInsures.filter((e) =>
			selectedCoInsuranceIds.includes(e.coInsureId),
		)
	} else {
		vueApp.$formData.product.coInsuranceSelectedId = coInsuranceListSelected.map((v) => v.coInsureId)
	}
	summary.coInsuranceSelected = coInsuranceListSelected

	// Benefit
	let additionalBenefits = summary.levelOfCover.benefits.filter((e) => e.isSelected),
		selectedAdditionalBenefitIds = vueApp.$formData.product.additionalBenefitSelectedListId
	if (additionalBenefits.length === 0) {
		additionalBenefits = summary.levelOfCover.benefits.filter((b) =>
			selectedAdditionalBenefitIds.includes(b.benefitID),
		)
	} else {
		let additionalBenefitSelectedListId = additionalBenefits.map((a) => a.benefitID)
		vueApp.$formData.product.additionalBenefitSelectedListId = additionalBenefitSelectedListId
	}
	summary.additionalBenefitsSelected = additionalBenefits

	summary.frequencySelected =
		summary.levelOfCover.premiumsAsPerPaymentFrequency.premiumBreakdownByPaymentFrequency.find(
			(f) => f.paymentFrequencyID == vueApp.$formData.product.frequencyId,
		)

	return summary
}
